// src/components/BusinessSuite/schedule/ScheduleTabs.js
import clsx from 'clsx';

const tabs = [
  { id: 'calendar', label: 'Schedule' },
  { id: 'timeoff',  label: 'Time-Off & Sick Leave' },
];

export default function ScheduleTabs({ active, onChange }) {
  return (
    <div className="flex space-x-2 mb-6">
      {tabs.map(t => (
        <button
          key={t.id}
          onClick={() => onChange(t.id)}
          className={clsx(
            'px-4 py-2 rounded-full text-sm font-medium transition',
            active === t.id
              ? 'bg-indigo-600 text-white shadow'
              : 'bg-gray-200 hover:bg-gray-300'
          )}
        >
          {t.label}
        </button>
      ))}
    </div>
  );
}
